import React from 'react'
import Body from './Layout/Body'
import StatisticPage from './components/StatisticPage'
const Statistic = () => {
  return (
    <><Body obj={<StatisticPage/>}/></>

  )
}

export default Statistic